var meta = { showLeftMenu: false, headIndex: 2 };
export var router = [
	{
		path: '/rootCauseAnalysis',
		meta: meta,
		name: 'rootCauseAnalysis',
		component: resolve => require(["./G6/components/G6Editor/index.vue"], resolve)
	},
	{
		path: '/topoDevice',
		meta: meta,
		name: 'topoDevice',
		component: resolve => require(["./G6/components/TroubleShootingEditor/index.vue"], resolve)
	},
]


// WEBPACK FOOTER //
// ./src/views/rootCause/router.js